import { fetchQuery } from "react-relay";
import {
    Environment,
    Store,
    RecordSource,
    Network,
    FetchFunction
} from "relay-runtime";

import {
    TemplateRecommendationsSearchResultsRelayQuery,
    getTemplateRecommendationsSearchResultsQueryVars
} from "../components/template-recommendations-search-results-relay";

export const useSearchRecommendations = async () => {
    const GATEWAY_URL =
        process.env["NODE_ENV"] != "production"
            ? "https://wac.stg.internal.atlassian.com/gateway/api/graphql"
            : "https://www.atlassian.com/gateway/api/graphql";

    const fetchGraphQL: FetchFunction = async (request, variables) => {
        const resp = await fetch(GATEWAY_URL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ query: request.text, variables })
        });
        if (!resp.ok) {
            throw new Error("Response failed.");
        }
        return await resp.json();
    };

    const environment = new Environment({
        store: new Store(new RecordSource({})),
        network: Network.create(fetchGraphQL)
    });

    const recommendationData = await fetchQuery(
        environment,
        TemplateRecommendationsSearchResultsRelayQuery,
        getTemplateRecommendationsSearchResultsQueryVars(window.location)
    )
        .toPromise()
        .then((data) => data)
        .catch((error) => {
            console.log(error);
        });

    return recommendationData;
};
